import type { RootState } from 'store';

export const selectResourceCurrenciesPrecisions = (state: RootState) => state.resource.currenciesPrecisions;
export const selectResourceSystemSettings = (state:RootState) => state.resource.systemSettings;
